<template>
  <div class="loader-wrapper">
    <div class="loader-container">
      <div class="spinner"></div>
      <span class="loader-text">
        {{ message }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    message: {
      type: String,
      default: "Loading..."
    }
  }
}
</script>

<style scoped>
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  width: 100%;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* ✅ centers spinner + text horizontally */
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(99, 102, 241, 0.2);
  border-top: 4px solid #6366f1;
  border-right: 4px solid #10b981;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
  box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);
}

.loader-text {
  color: #f3f4f6;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
